
const initialMessageMap = {
};

export default function (injection, Vue, otherMap = {}) {
    // &message
    const message = {
        _nextZIndex: 105000,
        _queue: [],
        _vcMap: {},
        _fnMap: {},
        /**
         * 添加一个message的Vue组件
         * @param  Constructor Vue组件
         * @param  name        索引名称
         */
        extend (Constructor, name) {
            this._vcMap[name] = Vue.extend(Constructor);
            if ('alias' in Constructor) {
                this.constructMessage(Constructor.alias, this._vcMap[name]);
            }
        },
        /**
         * 构建窗体
         * @param  FrameExtended Vue构造器
         * @param  options       传入组件init方法的options
         * @return               [description]
         */
        build (FrameExtended, options) {
            let ext = new FrameExtended({
                store: injection.store,
                router: injection.router
            }).$mount();
            ext.$el.style.zIndex = message._nextZIndex++;
            ext.close = function () {
                let that = this;
                Vue.nextTick(() => {
                    let i;
                    for (i = 0; i < message._queue.length; i++) {
                        if (message._queue[i] === that) {
                            message._queue.splice(i, 1);
                            break;
                        }
                    }
                    document.body.removeChild(that.$el);
                    that.$destroy(true);
                    setTimeout(() => {
                        message._queue.forEach((v, i) => {
                            message.adjustPosition(v, i + 1);
                        });
                    });
                });
            };
            let elIndex = message._queue.push(ext);
            Vue.nextTick(() => {
                document.body.appendChild(ext.$el);
                // 创建完毕，调用message的messageCreated
                if ('messageCreated' in FrameExtended.sealedOptions) {
                    Vue.nextTick(() => {
                        let defaultOptions =
                            ('defaultOptions' in FrameExtended.sealedOptions)
                                ? (FrameExtended.sealedOptions.defaultOptions()) : {};
                        FrameExtended.sealedOptions.messageCreated.call(ext, Object.assign(defaultOptions, options));
                        Vue.nextTick(() => {
                            message.adjustPosition(ext, elIndex);
                        });
                    });
                }
            });
        },
        /**
         * 使message窗体靠右，并计算对应top
         * @param  {[type]} frameInstance [description]
         * @param index
         * @return {[type]}               [description]
         */
        adjustPosition (frameInstance, index) {
            setTimeout(() => {
                console.log(defaultTop);
                frameInstance.$el.style.top = `${defaultTop}px`;
                frameInstance.$el.querySelector('.nt').classList.add('show');
            }, 10);
            let defaultTop = 26;
            let $lastMessage = null;
            if (index) {
                $lastMessage = message._queue[index - 2];
                if ($lastMessage) {
                    const rect = $lastMessage.$el.getBoundingClientRect();
                    defaultTop = $lastMessage.currentTop + rect.height + 10;
                }
                frameInstance.currentTop = defaultTop;
            } else {
                $lastMessage = message._queue[message._queue.length - 2];
                if ($lastMessage) {
                    const rect = $lastMessage.$el.getBoundingClientRect();
                    defaultTop = rect.top + rect.height + 10;
                }
            }

        },
        constructMessage (alias, FrameExtended) {
            message._fnMap[alias] = function (options) {
                return message.build(FrameExtended, options);
            };
            Object.defineProperty(message, alias, {
                get () {
                    return message._fnMap[alias];
                }
            });
        }
    };

    Object.defineProperties(injection, {
        message: {
            get () {
                return message;
            }
        }
    });
    Object.defineProperties(Vue.prototype, {
        $message: {
            get () {
                return message;
            }
        }
    });

    Object.keys(otherMap).forEach(val => {
        initialMessageMap[val] = otherMap[val];
    });

    for (let i in initialMessageMap) {
        message.extend(initialMessageMap[i], i);
    }
}
